import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import orderBy from 'lodash/orderBy';
import cx from 'classnames';
import {
  Button, VenueCardGrid, Loader, Link,
} from '@resy/ui-kitchen';
import AmexShopSmallSelector from '../AmexShopSmallSelector';
import AmexShopSmallEditorial from '../AmexShopSmallEditorial';
import AmexShopSmallEnrollOffer from '../AmexShopSmallEnrollOffer';
import { AFTER_SHOPSMALL, NAME_SHOP_SMALL } from '../constants';
import './AmexShopSmallSpendAndGet.scss';
import { postFinderList } from '../../../../../../ui-kitchen/src/api/api';
import { finder4Transform } from '../../../../../../ui-kitchen/src/api/resyApiTransformer';
import { getResyLocationsByCodeThunk, setSelectedLocationThunk } from '../../../../../../ui-kitchen/src/reducers/resyLocationsSlice';
import { setSelectedCoreISODate, setSelectedCoreSeats, setSelectedCoreTime } from '../../../../../../ui-kitchen/src/reducers/resyCoreSlice';
import { ALL_DAY } from '../../../../../../ui-kitchen/src/constants/resyCore';
import Logger from '../../../../../../ui-kitchen/src/utils/logger';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';

class AmexShopSmallSpendAndGet extends React.Component {
  static propTypes = {
    spendAndGetConfig: PropTypes.shape({
      city_venue_mappings: PropTypes.arrayOf(PropTypes.shape({ id: '' })),
      id: PropTypes.string,
      selector_group_info_screenreader: PropTypes.string,
      section_title: PropTypes.string,
      before: PropTypes.shape({ section_intro1: PropTypes.string }),
      during: PropTypes.shape({ section_intro1: PropTypes.string }),
      after: PropTypes.shape({ section_intro1: PropTypes.string }),
      section_intro2: PropTypes.string,
      terms_apply: PropTypes.shape({}),
    }).isRequired,
    $rootScope: PropTypes.shape({
      $digest: PropTypes.func,
    }).isRequired,
    loadNotifyModal: PropTypes.func.isRequired,
    defaultCity: PropTypes.shape({ code: PropTypes.string.isRequired, name: PropTypes.string.isRequired }).isRequired,
    eventTiming: PropTypes.string.isRequired,
    matchMedia: PropTypes.shape({
      xs: PropTypes.bool,
      sm: PropTypes.bool,
      md: PropTypes.bool,
      lg: PropTypes.bool,
      xl: PropTypes.bool,
    }).isRequired,
    $location: PropTypes.shape({
      search: PropTypes.func.isRequired,
    }).isRequired,
    Analytics: PropTypes.shape({ event: PropTypes.func.isRequired }).isRequired,
    taggingConfig: PropTypes.shape({
      spend_and_get: PropTypes.shape({
        context: PropTypes.string,
        selector: PropTypes.shape({}),
        venue_card: PropTypes.shape({}),
        city_selector: PropTypes.shape({
          city_pill_click_event: PropTypes.string,
        }),
      }).isRequired,
    }).isRequired,
    baseRequestUrl: PropTypes.string.isRequired,
    editorialConfig: PropTypes.shape({
      title: PropTypes.string,
      subtitle: PropTypes.string,
      contents: PropTypes.shape({}),
    }).isRequired,
    handleTagging: PropTypes.func.isRequired,
    enrollOfferConfig: PropTypes.shape({}).isRequired,
    scrollTo: PropTypes.func.isRequired,
    hideEnrollOffer: PropTypes.bool.isRequired,
    toggleTerms: PropTypes.func.isRequired,
    showAuthModal: PropTypes.func.isRequired,
    favoriteVenueIds: PropTypes.arrayOf(PropTypes.number).isRequired,
    dispatch: PropTypes.func.isRequired,
    $window: PropTypes.shape({}).isRequired,
  }

  state = {
    spendAndGetVenueList: [],
    loading: true,
    noDataToDisplay: false,
    selectedCityCode: 'ny',
    selectedCityName: '',
    selectedCity: null,
    noOfVenuesSpendAndGet: 0,
    selectedDateObject: null,
    selectedLocation: null,
  };

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState) {
    const { selectedCity } = this.state;
    const { selectedDateObject } = this.state;
    if (prevState.selectedDateObject !== selectedDateObject) {
      const { defaultCity = { code: 'ny', name: 'New York City' } } = this.props;
      if (selectedCity) {
        this.getVenueIds(selectedCity);
      } else {
        this.getVenueIds(defaultCity);
      }
    }
  }

  getVenueDetails = async (venueIds, venuArr) => {
    const {
      $rootScope,
      $window,
      dispatch,
    } = this.props;

    const { selectedDateObject } = this.state;

    const {
      date: selectedDate,
      seats: selectedSeats,
      time: selectedTime,
    } = selectedDateObject;

    const params = {
      day: selectedDate,
      party_size: selectedSeats,
      time_filter: selectedTime === ALL_DAY ? undefined : moment(selectedTime, 'HHmm').format('HH:mm'),
      venue_id: venueIds,
      resy_token: undefined,
      lat: 0,
      long: 0,
    };

    let venueResponseList = null;
    let apiResponse = null;
    try {
      const response = await postFinderList(params);
      apiResponse = finder4Transform(response);
      venueResponseList = apiResponse?.results.venues;

      if (venueResponseList) {
        venuArr = venuArr.map((str, index) => ({ value: str, id: index + 1 }));

        venueResponseList = venueResponseList.map((item) => {
          const venuArrObj = venuArr?.find((o) => Number(o.value) === item.venue.id);
          item.index = venuArrObj.id;
          return item;
        });

        const venueResponseListSorted = venueResponseList.sort((a, b) => a.index - b.index);

        this.setState({
          spendAndGetVenueList: venueResponseListSorted,
          loading: false,
          noDataToDisplay: false,
        });

        const { selectedCityCode } = this.state;
        const selectedLocation = await dispatch(getResyLocationsByCodeThunk(selectedCityCode));

        const locParams = {
          location: selectedLocation,
          $rootScope,
          $window,
        };
        dispatch(setSelectedLocationThunk(locParams));
        // selectedDate is in ISO Date format
        dispatch(setSelectedCoreISODate(selectedDate));
        dispatch(setSelectedCoreSeats(selectedSeats));
        dispatch(setSelectedCoreTime(selectedTime));

        this.setState({ selectedLocation });
      }
    } catch (error) {
      if (error.status === 400) {
        Logger.error('ERROR [AmexShopSmallSpendAndGet] - Error API Response -- ', error.data?.data);
        this.setState({ loading: false });
        this.setState({ spendAndGetVenueList: [] });
      }
    }
  }

  getCityVenueIds = (cityCode) => {
    let cityVenueIds = '';
    const {
      spendAndGetConfig: {
        city_venue_mappings: cityVenueMappings,
      },
    } = this.props;
    cityVenueIds = cityVenueMappings.find((itemValue) => itemValue.code === cityCode);
    return cityVenueIds;
  }

  getVenueIds = (item) => {
    this.setState({ selectedCityCode: item.code, selectedCityName: item.name });
    this.setState({ selectedCity: item });
    this.setState({ spendAndGetVenueList: [] });

    const cityVenueIds = this.getCityVenueIds(item.code);
    this.setState({ loading: true });

    if (cityVenueIds) {
      const venueIds = cityVenueIds.venue_ids;
      const venuArr = venueIds ? venueIds.split(',') : 0;
      this.setState({ noOfVenuesSpendAndGet: venuArr.length });
      if (venueIds && venuArr.length > 0) {
        this.getVenueDetails(venueIds, venuArr);
      } else {
        this.setState({
          spendAndGetVenueList: [], loading: false, noDataToDisplay: true,
        });
      }
    } else {
      this.setState({
        spendAndGetVenueList: [], loading: false, noDataToDisplay: true,
      });
    }
  }

  cityButton = (item) => {
    const { selectedCityCode, loading } = this.state;
    const {
      Analytics, taggingConfig: {
        spend_and_get: {
          city_selector: {
            city_pill_click_event: cityPillClickEventName,
          },
        },
      },
      $location,
    } = this.props;
    const searchResults = document.querySelector('.AmexShopSmallSelector__notification');

    return (
      <li key={item.code}>
        <Button
          variant="no-style"
          type="button"
          {...(selectedCityCode === item.code ? { 'aria-current': 'page' } : {})}
          {...loading === true ? { disabled: true } : ''}
          className={cx('AmexShopSmallSpendAndGet__citypanel__button', {
            selectedcity: (selectedCityCode === item.code),
          })}
          onClick={() => {
            $location.search('city', null).replace();
            this.getVenueIds(item);
            Analytics.event(cityPillClickEventName, {
              category: 'Shop Small Interaction',
              context: 'Shop Small Page',
            });
            searchResults.focus();
          }}
        >
          {item.name}
        </Button>
      </li>
    );
  }

  cityButtonPanel = () => {
    const {
      spendAndGetConfig: {
        city_venue_mappings: cityVenueMappings,
      },
    } = this.props;

    const orderedCityVenueMappings = orderBy(cityVenueMappings, ['id'], ['asc']);
    const cities = orderedCityVenueMappings.map((value) => ({ code: value.code, name: value.name }));
    return (
      <ul className="AmexShopSmallSpendAndGet__citypanel">
        {cities.map((item) => this.cityButton(item))}
      </ul>
    );
  };

  loadingComponent = () => (<div><Loader className="AmexShopSmallSpendAndGet__loader" /></div>);

  handleSeeMoreClick = () => {
    const {
      handleTagging,
    } = this.props;

    const { selectedCityCode } = this.state;

    const defaultParams = {
      location: selectedCityCode,
      type: 'Collection',
      list: NAME_SHOP_SMALL,
    };
    handleTagging('Shop Small See More CTA', defaultParams);
  };

  renderVenueGrid = () => {
    const {
      loadNotifyModal,
      $rootScope,
      Analytics: { event },
      taggingConfig: {
        spend_and_get: {
          venue_card: venueCardConfig,
        },
      },
      showAuthModal, favoriteVenueIds,
      matchMedia,
    } = this.props;

    const { selectedDateObject, selectedLocation } = this.state;
    let renderComp = '';

    if (!selectedDateObject) return renderComp;

    const {
      date: selectedDate,
      seats: selectedSeats,
    } = selectedDateObject;

    const { date, time, seats } = selectedDateObject;
    const query = {
      seats,
      date,
      time,
    };

    const link = `/cities/${selectedLocation?.url_slug}/search`;
    const {
      spendAndGetVenueList, loading, noDataToDisplay, noOfVenuesSpendAndGet,
    } = this.state;

    if (loading === true) {
      renderComp = this.loadingComponent();
    } else if (noDataToDisplay === true) {
      const displayText = `There are ${noOfVenuesSpendAndGet} Restaurant(s) available. To see availability, adjust your date or party size above.`;

      renderComp = (
        <p
          className="AmexShopSmallSpendAndGet__notification-error"
          role="status"
        >
          {displayText}
        </p>
      );
    } else if (loading === false) {
      let displayErrorTextRender = '';
      const displayTextError = 'To see availability, adjust your date or party size above.';

      if (noOfVenuesSpendAndGet > spendAndGetVenueList.length) {
        displayErrorTextRender = (
          <>
            <p className="AmexShopSmallSpendAndGet__notification-error" role="status">
              {displayTextError}
            </p>
          </>
        );
      }
      const isMobile = !matchMedia.md;
      const MAX_CARDS = 5;
      renderComp = (
        <>
          {displayErrorTextRender}
          <div
            className={`AmexShopSmallSpendAndGet__venuegrid__body card-${spendAndGetVenueList.length}-list`}
          >
            <VenueCardGrid
              $rootScope={$rootScope}
              userIsGda={false}
              event={event}
              list="Shop Small"
              loadNotifyModal={loadNotifyModal}
              restaurants={spendAndGetVenueList}
              selectedDate={selectedDate}
              selectedSeats={selectedSeats}
              limit={spendAndGetVenueList.length}
              isGda={false}
              isAmexShopSmallOffersFlag
              isAmexShopSmallFlag
              shopSmallVenueCardEvents={venueCardConfig}
              showAuthModal={showAuthModal}
              favoriteVenueIds={favoriteVenueIds}
              matchMedia={matchMedia}
              isMobile={isMobile}
              showCarouselButtons={spendAndGetVenueList.length > MAX_CARDS}
              link={{ pathname: link, query }}
              handleSeeMoreClick={this.handleSeeMoreClick}
            />
          </div>
        </>
      );
    }

    return renderComp;
  }

  getSelectedDateObject = (dateObject) => {
    this.setState({ selectedDateObject: dateObject });
  }

  renderSelector = () => {
    const {
      matchMedia,
      $rootScope,
      $location,
      Analytics,
      spendAndGetConfig: {
        selector_group_info_screenreader: selectorInfoSr,
      },
      taggingConfig: {
        spend_and_get: {
          context,
          selector: selectorTagConfig,
        },
      },
    } = this.props;
    const {
      selectedCityCode,
      selectedCityName,
      noOfVenuesSpendAndGet,
    } = this.state;
    const displayText = `${noOfVenuesSpendAndGet} Restaurant(s) in ${selectedCityName}`;
    return (
      <AmexShopSmallSelector
        matchMedia={matchMedia}
        $rootScope={$rootScope}
        getSelectedDateObject={this.getSelectedDateObject}
        $location={$location}
        Analytics={Analytics}
        selectedCityCode={selectedCityCode}
        selectorInfoSr={selectorInfoSr}
        selectorTagConfig={selectorTagConfig}
        context={context}
        displayText={displayText}
      />
    );
  }

  handleScroll = (url) => {
    const { toggleTerms, scrollTo } = this.props;
    const currentHash = url.replace('#', '');
    toggleTerms(currentHash);
    setTimeout(() => {
      scrollTo(url);
    }, 100);
  };

  displayCTA = (cta, name) => {
    const { label, url } = cta;
    switch (name) {
      case 'termsApply':
        return (
          <Link
            className="AmexShopSmallSpendAndGet__link"
            key={label}
            href={url}
            variant="no-style"
            onClick={() => { this.handleScroll(url); }}
          >
            { label }
          </Link>
        );
      default:
        return (null);
    }
  };

  render() {
    const {
      baseRequestUrl,
      editorialConfig,
      handleTagging,
      spendAndGetConfig,
      taggingConfig,
      enrollOfferConfig,
      eventTiming,
      hideEnrollOffer,
      scrollTo,
      toggleTerms,
    } = this.props;

    const {
      id: hashId,
      section_title: sectionTitle,
      section_intro2: sectionIntro2,
      terms_apply: termsApplyLink,
    } = spendAndGetConfig;

    const { selectedCityCode } = this.state;

    const hasEditorials = editorialConfig?.contents && editorialConfig?.contents[selectedCityCode];

    const sanitizedSectionTitle = sanitizeString(sectionTitle);
    const sanitizedSectionIntro1 = sanitizeString(spendAndGetConfig?.[eventTiming]?.section_intro1);
    const sanitizedSectionIntro2 = sanitizeString(sectionIntro2);

    return (
      <>

        <section className="AmexShopSmallSpendAndGet">
          <div className="container">
            <div className="AmexShopSmallSpendAndGet__wrapper">
              <h2
                id={hashId}
                className="AmexShopSmallSpendAndGet__title"
                dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                  __html: sanitizedSectionTitle,
                }}
              />
              <p className="AmexShopSmallSpendAndGet__intro">
                <span
                  dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                    __html: sanitizedSectionIntro1,
                  }}
                />
                {!(eventTiming === AFTER_SHOPSMALL) && this.displayCTA(termsApplyLink, 'termsApply')}
              </p>
              {!hideEnrollOffer && !(eventTiming === AFTER_SHOPSMALL) && (
              <>
                <p
                  className="AmexShopSmallSpendAndGet__intro"
                  dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                    __html: sanitizedSectionIntro2,
                  }}
                />

                <AmexShopSmallEnrollOffer
                  enrollOfferConfig={enrollOfferConfig}
                  handleTagging={this.handleTagging}
                  scrollTo={scrollTo}
                  tagConfig={taggingConfig}
                  toggleTerms={toggleTerms}
                />
              </>
              )}
              <nav className="AmexShopSmallSpendAndGet__citywrapper" aria-label="Participating restaurants">{this.cityButtonPanel()}</nav>
              {this.renderSelector()}
              {this.renderVenueGrid()}
              {!!hasEditorials && (
                <AmexShopSmallEditorial
                  baseRequestUrl={baseRequestUrl}
                  selectedCode={selectedCityCode}
                  editorialConfig={editorialConfig}
                  handleTagging={handleTagging}
                  tagConfig={taggingConfig}
                  type="spendAndGet"
                />
              )}
            </div>
          </div>
        </section>

      </>
    );
  }
}

export { AmexShopSmallSpendAndGet as ComponentUnderTest };
export default connect()(AmexShopSmallSpendAndGet);
